export default {"src":"/_next/static/media/01_Telegram_PT.1415a446.gif","height":175,"width":439};